import { connect } from 'react-redux';
import { JoinPartnersView } from './view';
import { trackJoinPartnersClick } from '../eventTracking';

const mapDispatchToProps = {
    trackJoinPartnersClick,
};

const JoinPartnersPanel = connect(undefined, mapDispatchToProps)(JoinPartnersView);
export default JoinPartnersPanel;
